import React from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from 'styled-components';
import { GlType } from '~/types/account';
import { glTypeLabel } from '~/utils/account';

interface Props {
  code?: GlType;
  variant?: 'icon' | 'text';
  style?: CSSProperties;
  className?: string;
}

const GlTypeIcon = (props: Props) => {
  const { code, variant = 'icon', style, className } = props;
  const classes = useStyles();
  const translate = useTranslate();

  if (!code) return null;

  if (variant === 'text') {
    return <span style={style}>{translate(glTypeLabel(code))}</span>;
  }

  return (
    <span
      className={`${classes.badge} ${classes[code as GlType] || ''} ${className || ''}`}
      style={style}
      title={translate(glTypeLabel(code))}
    >
      {code}
    </span>
  );
};

const useStyles = makeStyles((theme) => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid currentColor',
    borderRadius: 4,
    fontFamily: theme.typography.fontFamily,
    fontSize: 10,
    fontWeight: 600,
    lineHeight: 1,
    padding: 2,
    marginRight: 6,
    whiteSpace: 'nowrap',
    minWidth: 20,
  },
  LAS: { color: '#E74C3C' },
  LIA: { color: '#E74C3C' },
  ALS: { color: '#27AE60' },
  AST: { color: '#27AE60' },
  REV: { color: '#1ABC9C' },
  EXP: { color: '#F39C12' },
  EQT: { color: '#2962FF' },
  OBS: { color: '#95A5A6' },
}));

export default GlTypeIcon;
